// ModalSelecaoEmbalagens.tsx
import React from "react";
import { AiOutlineClose } from "react-icons/ai";

interface Props {
  open: boolean;
  onClose: () => void;
  filtro: string;
  setFiltro: (valor: string) => void;
  embalagens: any[];
  onSelect: (item: any) => void;
}

const ModalSelecaoEmbalagens: React.FC<Props> = ({
  open,
  onClose,
  filtro,
  setFiltro,
  embalagens,
  onSelect
}) => {
  if (!open) return null;

  return (
    <div className="content-edit">
      <div
        className="info-content-edit"
        style={{ height: "65%", overflowY: "auto", position: "relative" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <h1 style={{ margin: 0 }}>Embalagens</h1>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              marginLeft: 8,
              padding: 4,
              borderRadius: "50%",
              transition: "background 0.5s",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            aria-label="Fechar"
          >
            <AiOutlineClose size={24} color="#d83123" />
          </button>
        </div>
        <div
          className="divInput"
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            margin: "20px auto",
          }}
        >
          <label
            style={{ color: "#66afe9", fontWeight: "bold" }}
          >
            Filtrar
          </label>
          <input
            className="input-sign-in"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </div>
        {
          embalagens.map((item: any) => (
            <button
              key={item.idEmbalagem}
              className="button-select-defeito styled-defeito-btn"
              onClick={() => onSelect(item)}
              type="button"
            >
              {item.material}
            </button>
          ))}
        {/* {filtradas.map((item: any) => (
          <button
            key={item.id_material_sap}
            className="button-select-defeito styled-defeito-btn"
            onClick={() => onSelect(item)}
            type="button"
          >
            {item.material}
          </button>
        ))}
        {filtradas.length === 0 && (
          <div style={{ color: "#888", marginTop: 16 }}>
            Nenhuma embalagem disponível
          </div>
        )} */}
      </div>
    </div>
  );
};

export default ModalSelecaoEmbalagens;
